(function (Drupal, once) {

  const stateChecker = function(block) {
    if (block.classList.contains('show-overlay')) {
      block.classList.remove('show-overlay');
      document.body.classList.remove('vliz-search-overlay-open');
    } else {
      block.style.display = 'block';

      setTimeout(() => {
        block.classList.add('show-overlay');
        document.body.classList.add('vliz-search-overlay-open');
      }, 20);

      block.querySelector('.form-search').focus();
    }
  }

  Drupal.behaviors.vlizSearch = {

    attach(context, settings) {
      const submitButtons = once('vliz-search-submit-icons', '.vliz-search-submit');
      const block = once('vliz-search-overlays', '.block-vliz-search-block').shift();

      submitButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const form = button.closest('form');

          if (form) {
            form.submit();
          }
        });
      });

      if (block) {
        const trigger = once('vliz-search-overlay-trigger', '.vliz-search-trigger').shift();
        const closeBtn = block.querySelector('.close-search-overlay');

        document.body.addEventListener('keydown', (e) => {
          if (e.key == 'Escape' && block.classList.contains('show-overlay')) {
            stateChecker(block);
          }
        });

        block.addEventListener('transitionend', () => {
          if (!block.classList.contains('show-overlay')) {
            setTimeout(() => {
              block.style.display = 'none';
            }, 20);
          }
        });

        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          stateChecker(block);
        });

        if (trigger) {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            stateChecker(block);
          });
        }
      }
    }
  }

}(Drupal, once));
